// extracted by mini-css-extract-plugin
module.exports = {"Calendar":"Calendar_Calendar__NKOif"};